module.exports = __webpack_public_path__ + "img/6.663adf6f.jpg";